module.exports = __webpack_public_path__ + "img/flippeducatorshk.4430d400.png";